import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-strip-list-item',
  templateUrl: './strip-list-item.component.html',
  styleUrls: ['./strip-list-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class StripListItemComponent implements OnInit {

  @Input() autoHeight: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
